import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const PieChart = ({ 
  providers, 
  totalEncounters, 
  signedEncounters, 
  unsignedEncounters, 
  nonduplicatePatcount, 
  CPTCount, 
  UnitCount 
}) => {


  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        width: 400,
        type: "pie",
      },
      labels: [],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 250,
            },
            legend: {
              position: "right",
             
            },
          },
        },
      ],
    },
  });

 

  useEffect(() => {
    if (providers.length > 0) {
      const seriesData = [
        totalEncounters.reduce((acc, val) => acc + val, 0),
        signedEncounters.reduce((acc, val) => acc + val, 0),
        unsignedEncounters.reduce((acc, val) => acc + val, 0),
        nonduplicatePatcount.reduce((acc, val) => acc + val, 0),
        CPTCount.reduce((acc, val) => acc + val, 0),
        UnitCount.reduce((acc, val) => acc + val, 0),
      ];
  
      const labels = [
        "Total Encounters",
        "Signed Encounters",
        "Unsigned Encounters",
        "Total Patients",
        "Total CPTs",
        "Total Units",
      ].map((label, index) => `${label}: ${seriesData[index]}`);
  
      setChartData({
        series: seriesData,
        options: {
          ...chartData.options,
          labels: labels,
        },
      });
    }
  }, [providers, totalEncounters, signedEncounters, unsignedEncounters, nonduplicatePatcount, CPTCount, UnitCount]);
  

  return (
    <div>
      <div id="chart" style={{ width: "900px", marginLeft: "300px", marginTop:'80px' }}>
        <ReactApexChart 
          options={chartData.options} 
          series={chartData.series} 
          type="pie" 
          width={800} 
        />
      </div>
    </div>
  );
};

export default PieChart;
